import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { SourceOfFundsType } from '../../@types/sourceOfFundsType';
import URLConstants from 'constants/urlConstants';

type SourceOfFundstate = {
    isLoading: boolean;
    error: boolean;
    sourceOfFunds: SourceOfFundsType[];
}

const initialState: SourceOfFundstate = {
    isLoading: false,
    error: false,
    sourceOfFunds: [],
}

const slice = createSlice({
    name: 'sourceOfFunds',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET SOURCE  OF FUNDS
        getSourceOfFundsSuccess(state, action) {
            state.isLoading = false;
            state.sourceOfFunds = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function getSourceOfFunds() {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get(URLConstants.SOURCE_OF_FUNDS_BASE_URL);
        dispatch(slice.actions.getSourceOfFundsSuccess(response.data.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }